// extracted by mini-css-extract-plugin
export var chevron = "_i1-2";
export var dropdownItems = "_i1-0";
export var item = "_i1-1";